//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd January 2018
//  * @type            Survey Edit Component File
//  * @description -   This file renders the html and functionality for editing a  survey in app.
<template>
  <v-wait for="editing survey">
    <!-- <div id="loadingdiv">
      <img src="../assets/images/loader.gif">
    </div> -->
    <div id="loadingDiv" class="loadingDiv_analytics">
        <div class="loadersec">
          <div class="loader"></div>
        </div>
    </div>
  </v-wait>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EditSurvey",
  data() {
    return {
      data: []
    };
  },
  computed: {
   ...mapGetters("LeftSidebarCreate", ["all"])
  },
  watch: {
    all: {
      handler(newVal) {
        if (this.all.flag == 1) {
          this.$router.push({
            name: "EditDashboard",
            params: { id: this.$route.params.id }
          });
          localStorage.setItem("in_survey_Id", this.all.in_survey_Id);
          this.$session.set("in_survey_Id", this.all.in_survey_Id);
          // this.$awn.success('Edit Survey')
        } else if (this.all.flag == 0) {
          this.$awn.alert(this.all.msg);
        } else {
          this.$awn.alert(this.all.msg);
        }
      }
    }
  },
  methods: {
    ...mapActions("LeftSidebarCreate", ["getSurveyById"])
  },
  async created() {
    this.$wait.start("editing survey");

    this.data = this.$session.getAll();
    this.data["in_survey_Id"] = this.$route.params.id;
    await this.getSurveyById(this.data);
    // stop waiting
    this.$wait.end("editing survey");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditSurvey.vue